import { Link } from 'react-router-dom';
import type { Category } from '@/mocks/categories';

interface CategoryCardProps {
  category: Category;
}

const colorMap: Record<string, { bg: string; text: string; hover: string }> = {
  accent: {
    bg: 'bg-accent-100/70',
    text: 'text-accent-700',
    hover: 'group-hover:bg-accent-200/80',
  },
  primary: {
    bg: 'bg-primary-100/70',
    text: 'text-primary-700',
    hover: 'group-hover:bg-primary-200/80',
  },
  secondary: {
    bg: 'bg-secondary-100/70',
    text: 'text-secondary-700',
    hover: 'group-hover:bg-secondary-200/80',
  },
};

export default function CategoryCard({ category }: CategoryCardProps) {
  const c = colorMap[category.color] || colorMap.primary;

  return (
    <Link
      to={`/category/${category.slug}`}
      className="group bg-background-50 border border-background-200/70 rounded-xl p-6 hover:border-primary-200 transition-all duration-300 flex flex-col items-center text-center"
    >
      <div className={`w-14 h-14 flex items-center justify-center rounded-xl ${c.bg} ${c.text} ${c.hover} transition-colors mb-4`}>
        <i className={`${category.icon} text-2xl`}></i>
      </div>
      <h3 className="text-base font-semibold text-foreground-950 mb-2 font-heading">{category.name}</h3>
      <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">{category.description}</p>
      <span className="text-xs text-foreground-500">{category.articleCount} 篇文章</span>
    </Link>
  );
}